import angular from 'angular'
import toaster from 'angularjs-toaster'

import localStorageService from 'common/local-storage.service'

import AbstractCollectionService from './abstract-collection.service'
import ApiService from './api.service'
import PrimusService from './primus.service'
import StateService from './state.service'

export { AbstractCollectionService }

export default angular.module('jumbotron.api', [localStorageService, toaster])
  .config(['toasterConfig', function (toasterConfig) {
    // Default is 5000ms, add 1500ms for longer visibility
    toasterConfig['time-out'] = 6500
  }])
  .service('PrimusService', PrimusService)
  .service('ApiService', ApiService)
  .service('StateService', StateService)
  .name
